<template>
  <div class="main-body">

    <div class="header">跌倒雷达</div>

    <div class="out" style="background-color: #fff;margin: 10px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="房间" name="room">
          <PartRoom ref="myPartRoom"></PartRoom>
        </el-tab-pane>
        <el-tab-pane label="老人" name="elderly">
          <PartElderly ref="myPartElderly"></PartElderly>
        </el-tab-pane>

      </el-tabs>
    </div>

  </div>
</template>

<script>

import PartRoom from "./PageRoomIns";
import PartElderly from "./PageElderlyIns";

export default {
  name: 'ElderlyInsCheckIn',
  data() {
    return {

      loading: false,
      activeName: '',

    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  components:{
    PartRoom,PartElderly
  },
  mounted() {
    this.init();
  },
  created() {
    this.th = this.$store.state.tableHeight;

  },
  methods: {
    init(){

      this.activeName = 'room';
      this.$refs.myPartRoom.init();

    },

    handleClick(tab, event) {
      //console.log(tab, event);
      //console.log(tab.name);

      if(tab.name == 'room'){
        this.$refs.myPartRoom.init();
      }
      if(tab.name == 'elderly'){
        this.$refs.myPartElderly.init();
      }

    },


  }
}


</script>

<style lang="scss" scoped>

</style>
